export const text = {
  loadingMessage: 'Estamos cargando tus productos',
  selectProducts: 'Selecciona los productos que quieres agregar a tu categoría',
  existingProductsTitle: 'Agregar producto existente',
  existingProductsSubTitle:
    'Selecciona los productos que quieres agregar a tu categoría',
  actionButtonText: (items) => `Agregar productos (${items?.length})`
};
